import { useMutation } from '@apollo/client';
import { useAdminContext } from "../../contexts/context";
import { UpdateChartDocument, useAddChartMutation as _useAddChartMutation, useDeleteChartMutation as _useDeleteChartMutation, useGetAllChartsLazyQuery as _useGetAllChartsLazyQuery, useGetAllChartsQuery as _useGetAllChartsQuery, } from '../generated/graphql-types';
export const useGetAllChartsQuery = (orgId) => {
    const { data, error, loading } = _useGetAllChartsQuery({
        variables: { orgId },
    });
    return {
        error,
        loading,
        data: data?.CustomChart_getAll,
    };
};
export const useGetAllChartsLazyQuery = (orgId) => {
    const { onError } = useAdminContext();
    const [getAllCharts, { data, error, loading }] = _useGetAllChartsLazyQuery({
        fetchPolicy: 'network-only',
        variables: { orgId },
        onError,
    });
    return {
        getAllCharts,
        error,
        loading,
        data: data?.CustomChart_getAll,
    };
};
export const useAddChartMutation = (orgId) => {
    const [addChartMutation, { data, error, loading }] = _useAddChartMutation();
    const addChart = async (name, description, sourceUrl, iconUrl, authorName, authorEmail, authorOrganisation, chartAppAccessToken) => {
        const result = await addChartMutation({
            variables: {
                name,
                description,
                sourceUrl,
                chartAppAccessToken,
                iconUrl,
                author: {
                    name: authorName,
                    email: authorEmail,
                    organisation: authorOrganisation,
                },
                orgId,
            },
        });
        return result?.data?.CustomChart_add;
    };
    return {
        addChart,
        data,
        error,
        loading,
    };
};
export const useDeleteChartMutation = (orgId) => {
    const [deleteChartMutation, { data, error, loading },] = _useDeleteChartMutation();
    const deleteChart = async (guid) => {
        const result = await deleteChartMutation({
            variables: {
                guid,
                orgId,
            },
        });
        return result?.data?.CustomChart_delete;
    };
    return {
        deleteChart,
        data,
        error,
        loading,
    };
};
export const useUpdateChartMutation = (orgId) => {
    const [updateChartMutation, { data, error, loading }] = useMutation(UpdateChartDocument);
    const updateChart = async (guid, name, description, sourceUrl, iconUrl, authorName, authorEmail, authorOrganisation, chartAppAccessToken) => {
        const result = await updateChartMutation({
            variables: {
                guid,
                name,
                description,
                sourceUrl,
                chartAppAccessToken,
                iconUrl,
                author: {
                    name: authorName,
                    email: authorEmail,
                    organisation: authorOrganisation,
                },
                orgId,
            },
        });
        return result?.data?.CustomChart_update;
    };
    return {
        updateChart,
        data,
        error,
        loading,
    };
};
//# sourceMappingURL=custom-chart-service.js.map